// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const eternatus_eternamax: PokeData = {
  "id": 10190,
  "name": "eternatus-eternamax",
  "height": 1000,
  "weight": 0,
  "base_experience": 563,
  "types": [
    PokeType.POISON,
    PokeType.DRAGON
  ],
  "api_moves": [
    "flamethrower",
    "hyper-beam",
    "toxic",
    "agility",
    "recover",
    "confuse-ray",
    "cosmic-power",
    "poison-tail",
    "dragon-dance",
    "dragon-pulse",
    "cross-poison",
    "venoshock",
    "dragon-tail",
    "dynamax-cannon",
    "eternabeam"
  ],
  "moves": [
    "flamethrower",
    "confuse-ray",
    "dragon-dance",
    "dragon-pulse",
    "acid",
    "outrage",
    "inner-spirit",
    "dragon-breath",
    "great-roar",
    "poison-jab",
    "poison-powder",
    "dragon-fang",
    "mortal-gas"
  ],
  "evolution_chain": {
    "id": 469,
    "item": null,
    "species": [
      {
        "name": "eternatus",
        "order": 890,
        "types": [
          PokeType.POISON,
          PokeType.DRAGON
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      }
    ]
  },
  "stats": {
    "resistance": 253,
    "speed": 130,
    "ability_power": 125
  },
  "stat_changes": [],
  "catch_rate": 255,
  "is_legendary": true,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
